import React, { Component } from "react";
import InstructionHeader from "./InstructionHeader";
import * as pageData from "./PageData";

var completionText;

export default class SafetyInstruction extends Component {
    constructor(props) {
        super(props);
        completionText = pageData.getStandardPracticeCompletedText();
        this.buttonClick = this.buttonClick.bind(this);
        this.state = {
            completed: false
        };
    }

    buttonClick(type) {
        if (type === "safe" || type === "unsafe") {
            this.setState({ completed: true });
            this.props.clearDisableNext();
            this.props.playSpeechForInstructionEnd(completionText);
        }
    }

    render() {
        const p = this.props;

        return (
<div className = "test-page-content-inner test-page-instruction test-page-safety-instruction" >
    <InstructionHeader content={p.content} />
    <div className="practice-content">
        {renderPractice(p, this.state, this.buttonClick)}
    </div>
</div>
        );
    }
}

function renderPractice(props, state, buttonClick) {
    if (state.completed === true) {
        const inner = completionText.map(function (str, index) {
            return (<p key={index + 1}>{str}</p>);
        });

        return (
            <div className="practice-completed">
                <i key="0" className="far fa-check"></i>
                {inner}
            </div>
        );
    }

    const disabled = props.waitingForSpeech ? 'disabled' : '';

    return (
        <div className="practice-content-inner">
            <div className="practice-col-1">
                <img alt="" src={'/images/safety/example.jpg'} width="520px" />
            </div>
            <div className="practice-col-2">
                <button className="btn btn-safety btn-safe btn-success" onClick={() => buttonClick("safe")} disabled={disabled}>SAFE</button>
                <button className="btn btn-safety btn-unsafe btn-danger" onClick={() => buttonClick("unsafe")} disabled={disabled}>UNSAFE</button>
            </div>
        </div>
    );
}
